module.exports = __webpack_public_path__ + "static/media/certified-medal.efa33c2a.svg";